import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DialogContainer, DialogContent, DialogTitle, DialogCloseButton } from '@shared/ui/Dialog';
import { useTranslationProject } from '@shared/lib/hooks';
import styles from './UploadFileDialog.module.scss';
import { DocumentUpload } from '@pages/Upload';
export function UploadFileDialog({ onClose }) {
    const { tproject } = useTranslationProject();
    return (_jsxs(DialogContainer, { classes: { paper: styles.uploadContainer }, open: true, children: [_jsxs(DialogTitle, { className: styles.title, variant: "h5", children: [tproject('Upload File'), _jsx(DialogCloseButton, { onClick: onClose })] }), _jsx(DialogContent, { className: styles.content, children: _jsx(DocumentUpload, { onClose: onClose }) })] }));
}
